<template>
  <div class="ai-visibility-form-step">
    <step-intro
      title="What brand should we track?"
      description="Enter your brand and website so we can detect mentions, links, and citations more accurately."
    />

    <form-text-input
      :value="brandName"
      label="Brand name*"
      placeholder="BMW"
      helper-text="Helps us catch citations and links to your site"
      :error="validationErrors.brandName"
      @input="$emit('update:brandName', $event)"
    />

    <form-text-input
      class="mt-4"
      :value="websiteUrl"
      label="Website*"
      placeholder="bmw.com"
      helper-text="Helps us catch citations and links to your site"
      :error="validationErrors.websiteUrl"
      @input="$emit('update:websiteUrl', $event)"
    />
  </div>
</template>

<script>
import FormTextInput from '../ui/FormTextInput.vue'
import StepIntro from '../ui/StepIntro.vue'

export default {
  name: 'BrandStep',
  components: {
    FormTextInput,
    StepIntro,
  },
  props: {
    brandName: {
      type: String,
      default: '',
    },
    websiteUrl: {
      type: String,
      default: '',
    },
    validationErrors: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
